import { render, staticRenderFns } from "./CoreNotifications.vue?vue&type=template&id=7d838077&scoped=true&"
import script from "./CoreNotifications.vue?vue&type=script&lang=js&"
export * from "./CoreNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CoreNotifications.vue?vue&type=style&index=0&id=7d838077&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d838077",
  null
  
)

export default component.exports